module.exports = "../../static/img/close_icon.7a6fdf1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/close_icon.png
// module id = 1452
// module chunks = 0